
import legacyEBPublish from '_utils/legacyEBPublish';

const pricingPage = {

  init() {
    /* HANDLERS AND UTILS:
    ================================================== */

    const _getAuthenticityToken = function () {
      return encodeURIComponent(
        $('.billing-form input[name=authenticity_token]').val(),
      );
    };

    const _billingFormCodeInputField = function () {
      return $_upgradePage
        .find('.billing-form .form-field.code .field-value.code-input')
        .first();
    };

    const _isUserLoggedIn = function () {
      if ('true' == $("meta[name='loggedIn']").attr('content')) {
        return true;
      } else {
        return false;
      }
    };

    const _upgradePageUrlWith = function (_planId) {
      var $_planCard = $_upgradePage.find(
        '.pricing-plan.card[data-plan-id=' + _planId + ']',
      );
      _planKey = $_planCard.data('plan-key');

      return _updateQueryString(window.location.href, 'key', _planKey);
    };

    const _getUrlParameter = function (sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return typeof sParameterName[1] === 'undefined'
            ? true
            : sParameterName[1];
        }
      }
    };

    const _updateQueryString = function (uri, key, value) {
      var hash = '';

      if (uri.indexOf('#') !== -1) {
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
      }

      var separator = uri.indexOf('?') !== -1 ? '&' : '?';

      return uri + separator + key + '=' + value + hash;
    };

    const dimension_value = _isUserLoggedIn() ? 1 : 0;
    BSC.gaDimensions.push({
      logged_state: 'logged_state',
      dimension_value: _isUserLoggedIn() ? 1 : 0,
    });

    /* setup Stripe:
    ================================================== */
    var stripe = Stripe($("meta[name='stripePublishableKey']").attr('content'));
    var elements = stripe.elements();

    // Create an instance of the card Element.
    var card = elements.create('card');

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');

    /* cache jQuery objects
    ================================================== */
    var $_upgradePage = $('.content.upgrade'),
      $_upgradePageContent = $_upgradePage.find('.upgrade-page-content');

    /* WIRE BEHAVIORS:
    ================================================== */

    /* Stripe element in billing form
    ================================================== */
    card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    /* Pre-plan-selection promo code prompt
    ================================================== */
    $_upgradePage.on('click', '.code-prompt', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (_isUserLoggedIn()) {
        $(this).hide();
        $_upgradePage.find('.code-form').trigger('reset').show();
      } else {
        _displaySignInOrUpModal();
      }
    });

    /* Pre-plan-selection promo code dismiss button
    ================================================== */
    $_upgradePage.on(
      'click',
      '#pre-plan-code-input .code-dismiss',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        $_upgradePage.find('.code-form').hide();
        $_upgradePage.find('.code-prompt').show();
      },
    );

    /* Pre-plan-selection promo code apply button
    ================================================== */
    $_upgradePage.on('click', '#pre-plan-code-input .code-apply', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // submit the form
      $(this).parent('#pre-plan-code-input').submit();
    });

    /* Pre-plan-selection promo code form submit
    ================================================== */
    $_upgradePage.on('submit', '#pre-plan-code-input', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var _theCode = $(this).find('.code-input').val(),
        $_codeInputForm = $('#pre-plan-code-input');

      // if non-null input, perform validation of code against API
      if (_theCode != '') {
        // turn on spinner, reset validation indicators
        $_codeInputForm.find('.code-apply').addClass('loading');
        $_codeInputForm.find('.code-input').removeClass('invalid');

        _validatePromoCode({
          promoCode: _theCode,
          success: function (result) {
            // turn off spinner, reset validation indicators
            $_codeInputForm.find('.code-apply').removeClass('loading');
            $_codeInputForm.find('.code-input').removeClass('invalid');
            $_codeInputForm.find('.form-guidance').text('').hide();

            if (
              typeof result.did_activate !== 'undefined' &&
              result.did_activate &&
              typeof result.subscription_id !== 'undefined' &&
              typeof result.subscription_plan_key != 'undefined'
            ) {
              // clear the ccd-details from the form
              $_upgradePage.find('.billing-form').get(0).reset();

              // GOTO Thanks Page:
              legacyEBPublish(
                'upgrade:purchase:access_code_redeemed',
                {},
                true,
              );
              location.href =
                '/subscriptions/thanks?id=' +
                result.subscription_id +
                '&key=' +
                result.subscription_plan_key;
            } else {
              // display Billing Form with selected Plan
              result.plans.forEach((plan) => {
                _displayBilling(null, plan);
              });
            }
          },
          error: function (result) {
            // turn off spinner, set validation indicators
            $_codeInputForm.find('.code-apply').removeClass('loading');
            $_codeInputForm.find('.code-input').addClass('invalid');
            $_codeInputForm.find('.form-guidance').text(result.message).show();
          },
        });
      }
    });

    /* Pro-features popovers
    ================================================== */
    $_upgradePage.on('click', '.pro-feature-header', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $_newPopover,
        _header,
        _bullets,
        _top,
        _left,
        $_proFeature = $(this);

      // perform popover if window is wider than 825 pixels. TODO: Replace this magic number which represents the width where features are displayed in a single column
      if ($(window).width() > 825) {
        // remove any pre-existing pro-feature popovers
        $_upgradePage.find('.pro-feature-popover.clone').remove();

        // collapse any currently expanded pro-feature sub bullets
        $_upgradePage.find('.popover-content').removeClass('expanded');

        // construct new popover, fill with pro-feature content
        $_newPopover = $_upgradePage
          .find('.pro-feature-popover')
          .clone()
          .addClass('clone');
        _header = $(this).parent().find('.pro-feature-header').text();
        _bullets = $(this).parent().find('.popover-list').html();
        $_newPopover.find('.popover-header').text(_header);
        $_newPopover.find('.popover-list').html(_bullets);

        // give popover behaviors for explicit close and loss of focus
        $_newPopover.on('click', '.popover-close', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _removePopover();
        });

        // handle user click inside popover
        $_newPopover.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // do nothing
        });

        // handle user click on the popover's parent pro-feature link
        $_proFeature.on('click.pro-feature', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _removePopover();
        });

        // handle user click outside popover
        $('body').on('click.popover', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _removePopover();
        });

        // determine where to display popover
        _top = $(this).offset().top - 290;
        _left = $(this).offset().left + 40;

        // display popover and give it focus
        $_newPopover.appendTo($_upgradePage).css({ top: _top, left: _left });
        $_newPopover.focus();
      } else {
        // toggle Pro Feature detail as sub bullets underneath main bullet
        $(this).siblings('.popover-content').toggleClass('expanded');
      }

      // private functions
      const _removePopover = function () {
        // remove the popover
        $_upgradePage.find('.pro-feature-popover.clone').remove();

        // unbind supporting event handlers
        $_proFeature.off('click.pro-feature');
        $('body').off('click.popover');
      };
    });

    /* Select a license info pane
    ================================================== */
    $_upgradePage.on('click', '.license-info.card', function (e) {
      e.preventDefault();
      e.stopPropagation();

      location.href = $(this).data('href');
    });

    /* Select a plan
    ================================================== */
    $_upgradePage.on('click', '.pricing-plan.card', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var _selectedPlanId = $(this).data('planId'),
        _activeCode = $('.billing-form .form-field.code .code-input').val(),
        $_clickedCard = $(this);

      if (_activeCode != '') {
        // turn on spinner
        $_clickedCard.find('.plan-call-to-action').addClass('loading');

        // gotta clean-up the billing-form too (in case it's already opened)
        $_upgradePage
          .find('.billing-form .form-field.code .field-guidance')
          .text('')
          .hide();
        $_upgradePage
          .find('.billing-form .form-field.code .code-input')
          .removeClass('invalid');

        // validate the code in the billing form and update form accordingly
        _validatePromoCode({
          promoCode: _activeCode,
          selectedPlanId: _selectedPlanId,
          success: function (result) {
            // turn off spinner, reset validation indicators
            $_clickedCard.find('.plan-call-to-action').removeClass('loading');

            if (
              typeof result.did_activate !== 'undefined' &&
              result.did_activate &&
              typeof result.subscription_id !== 'undefined' &&
              typeof result.subscription_plan_key != 'undefined'
            ) {
              // clear the ccd-details from the form
              $_upgradePage.find('.billing-form').get(0).reset();

              legacyEBPublish(
                'upgrade:purchase:access_code_redeemed',
                {},
                true,
              );

              // GOTO Thanks Page:
              location.href =
                '/subscriptions/thanks?id=' +
                result.subscription_id +
                '&key=' +
                result.subscription_plan_key;
            } else {
              // update pricing and billing form display
              _displayBilling(_selectedPlanId, result);
            }
          },
          error: function (result) {
            // turn off spinner, set validation indicators
            $_clickedCard.find('.plan-call-to-action').removeClass('loading');
            $_upgradePage
              .find('.billing-form .form-field.code .code-input')
              .addClass('invalid');
            $_upgradePage
              .find('.billing-form .form-field.code .field-guidance')
              .text(result.message)
              .show();
          },
        });
      } else {
        // display billing form with selected plan
        _displayBilling(_selectedPlanId);
      }
    });

    /* Present pre-selected plan and form in custom selling page (csp)
    ================================================== */
    $_upgradePage.on('click', '.csp-cta-button', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var _selectedPlanId = $(this).data('plan-id');

      // display billing form with selected plan
      _displayBilling(_selectedPlanId);
    });

    /* Toggle display of Pro Features
    ================================================== */
    $_upgradePage.on('click', '.pro-features-section-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // remove any open popovers
      $_upgradePage.find('.pro-feature-popover.clone').remove();

      // hide/show corresponding sections
      if ($(this).hasClass('not-showing-features')) {
        $_upgradePage.find('.pro-features').show();
        $_upgradePage
          .find('.pro-features-section-toggle')
          .removeClass('not-showing-features')
          .addClass('showing-features')
          .show();
      } else {
        $_upgradePage.find('.pro-features').hide();
        $_upgradePage
          .find('.pro-features-section-toggle')
          .removeClass('showing-features')
          .addClass('not-showing-features')
          .show();
      }
    });

    /* Post-plan-selection promo code apply button
    ================================================== */
    $_upgradePage.on(
      'click',
      '.billing-form .form-field.code .code-apply',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        var _theCode = $('.billing-form .form-field.code .code-input').val(),
          _selectedPlanId = $_upgradePage
            .find('.card.pricing-plan.selected')
            .data('plan-id');

        // if non-null input, perform validation of code against API
        if (_theCode != '') {
          // set spinners, clear validation indicators
          $(this).addClass('loading');
          $(this).siblings('.code-input').removeClass('invalid');

          // validate the inputted code
          _validatePromoCode({
            promoCode: _theCode,
            selectedPlanId: _selectedPlanId,
            success: function (result) {
              // turn off spinner, reset validation indicators
              $_upgradePage
                .find('.billing-form .form-field.code .code-apply')
                .removeClass('loading');
              $_upgradePage
                .find('.billing-form .form-field.code .code-input')
                .removeClass('invalid');
              $_upgradePage
                .find('.billing-form .form-field.code .field-guidance')
                .text('')
                .hide();

              if (
                typeof result.did_activate !== 'undefined' &&
                result.did_activate &&
                typeof result.subscription_id !== 'undefined' &&
                typeof result.subscription_plan_key != 'undefined'
              ) {
                // clear the ccd-details from the form
                $_upgradePage.find('.billing-form').get(0).reset();
                // GOTO Thanks Page:
                legacyEBPublish(
                  'upgrade:purchase:access_code_redeemed',
                  {},
                  true,
                );
                location.href =
                  '/subscriptions/thanks?id=' +
                  result.subscription_id +
                  '&key=' +
                  result.subscription_plan_key;
              } else {
                // display Billing Form with selected Plan
                _displayBilling(result.subscription_plan_id, result);
              }
            },
            error: function (result) {
              // turn on spinner, set validation indicators
              $_upgradePage
                .find('.billing-form .form-field.code .code-apply')
                .removeClass('loading');
              $_upgradePage
                .find('.billing-form .form-field.code .code-input')
                .addClass('invalid');
              $_upgradePage
                .find('.billing-form .form-field.code .field-guidance')
                .text(result.message)
                .show();
            },
          });
        }
      },
    );

    /* Post-plan-selection promo code clear button
    ================================================== */
    $_upgradePage.on(
      'click',
      '.billing-form .form-field.code .code-dismiss',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        var _selectedPlanId = $(
          '.billing-form .form-field.plan-id .field-value',
        ).val();

        // clear code input field, clear validation indicators
        $(this).siblings('.code-input').val('').removeClass('invalid');
        $(this).siblings('.field-guidance').text('').hide();

        // reset pricing on billing form
        _displayBilling(_selectedPlanId);
      },
    );

    /* Submit Billing Form
    ================================================== */
    $_upgradePage.on(
      'click',
      '.billing-form .submit-billing-form-button',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $self = $(this);

        // Display spinner
        $(this).addClass('loading');

        // Disable the submit button to prevent repeated clicks
        $(this).prop('disabled', true);

        $('#payment-errors').text(''); //clear errors

        legacyEBPublish('upgrade:purchase:started', {
          discount_code: $('.billing-form .field-value.code-input').val(),
          plan_name: $('.billing-form .selected-plan').text(),
          plan_price: $('.billing-form .selected-plan-price').text(),
        });

        // make call to Stripe to retrieve card info token
        stripe
          .createToken(card, { name: $('#full-name').val() })
          .then(function (result) {
            if (result.error) {
              // Inform the customer that there was an error.
              var errorElement = document.getElementById('card-errors');
              errorElement.textContent = result.error.message;

              legacyEBPublish(
                'upgrade:purchase:failed',
                { error: result.error.message },
                true,
              );

              // Re-enable the submit button on the form
              $self.prop('disabled', false);
              $self.removeClass('loading');
            } else {
              // Send the token to your server.
              _stripeTokenHandler(result.token);
            }
          });
      },
    );

    /* Dismiss Billing Form
    ================================================== */
    $_upgradePage.on('click', '.billing-form .form-dismiss', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!$_upgradePage.hasClass('custom-selling-page')) {
        // redirect to fresh display of pricing page
        location.href = '/pricing';
      } else {
        $_upgradePage.find('.csp-cta-button').show();
        $_upgradePage.find('.billing-form').hide();
      }
    });

    /*
    ==================================================
     PAGE TRANSFORMATIONS
    ==================================================
    */

    const _displayBilling = function (selectedPlanId, pricingData) {
      const _planId = selectedPlanId || pricingData.id,
        _pricingData = pricingData || null;

      let _planName, _planBillingPrice, $_selectedPlanCard;

      // update page if user is logged in. If not prompt to log in and then re-attempt
      if (_isUserLoggedIn()) {
        // remove any open popovers
        $_upgradePage.find('.pro-feature-popover.clone').remove();
        $_upgradePage.find('.csp-cta-button').hide();

        $_upgradePage.find('.card.license-info').hide();

        // suppress display of non-billing content
        _collapsePricingInfo();

        // clear display of any previous discounting
        _resetBillingDisplay();

        // update selected Pricing Plan card
        $_selectedPlanCard = $_upgradePage.find(
          '.pricing-plan.card[data-plan-id=' + _planId + ']',
        );
        $_selectedPlanCard.data('pricing-data', pricingData);
        $_selectedPlanCard.addClass('selected');

        // update Billing Form
        _planName = $_selectedPlanCard.data('plan-name');
        _planBillingPrice = $_selectedPlanCard.data('plan-price');
        $_upgradePage
          .find('.billing-form .selected-plan-info .selected-plan')
          .text(_planName);
        $_upgradePage
          .find('.billing-form .selected-plan-info .plan-billing-price')
          .text(_planBillingPrice);
        $_upgradePage
          .find('.billing-form .submit-billing-form-button .selected-plan-name')
          .text(_planName);
        $_upgradePage
          .find('.billing-form .form-field.plan-id .field-value')
          .val(_planId);

        // if pricing data is supplied, update for pricing (usually discounting)
        if (
          (_pricingData !== null && typeof _pricingData == 'object') ||
          $_selectedPlanCard.data('pricing-data') != null
        ) {
          // Leveraging a stored pricing-data in case they applied the code to all in general
          const pData = _pricingData || $_selectedPlanCard.data('pricing-data');
          _applyPricingAdjustments(pData);
        }

        // display features-toggle and Billing form
        $_upgradePage
          .find('.pro-features-section-toggle')
          .removeClass('showing-features')
          .addClass('not-showing-features')
          .show();
        $_upgradePage.find('.billing-form').show();
      } else {
        var reEntryUrl;

        if (!$_upgradePage.hasClass('custom-selling-page')) {
          reEntryUrl = window.location.href;
        } else {
          reEntryUrl = _updateQueryString(
            window.location.href,
            'cspReEntry',
            'true',
          );
        }

        $.ajax({
          url: '/pricing/set_reminder',
          data: {
            // 'after_sign_up_or_sign_in_url': _upgradePageUrlWith(_planId)
            after_sign_up_or_sign_in_url: reEntryUrl,
          },
          type: 'POST',
        })
          .done(function () {
            // open the signInOrUp dialog
            _displaySignInOrUpModal();
          })
          .fail(function (data) {
            // intentionally blank
          });
      }
    };

    const _collapsePricingInfo = function () {
      // suppress display of non-billing content
      $_upgradePage.find('.upgrade-page-header').addClass('collapsed');
      $_upgradePage.find('.code-entry').hide();
      $_upgradePage.find('.pro-features').hide();

      // update pricing plan cards
      $_upgradePage
        .find('.pricing-plan.card')
        .removeClass('selected')
        .addClass('collapsed');
      $_upgradePage
        .find('.pricing-plan.card .plan-call-to-action')
        .text('Select this plan');
    };

    const _resetBillingDisplay = function () {
      // reset pricing cards
      // $_upgradePage.find('.pricing-plan.card').removeClass('selected').removeClass('discounted');
      // $_upgradePage.find('.pricing-plan.card .plan-price .discount-monthly-price').remove();
      // $_upgradePage.find('.pricing-plan.card .plan-price .discount-lump-price').remove();
      // $_upgradePage.find('.pricing-plan.card .plan-price-info .discount-billing-price').remove();

      // reset billing form pricing data
      $_upgradePage
        .find('.billing-form .selected-plan-info')
        .removeClass('discounted');
      $_upgradePage
        .find('.billing-form .selected-plan-info .selected-plan')
        .text('');
      $_upgradePage.find('.billing-form .selected-plan-info .savings').remove();
      $_upgradePage
        .find('.billing-form .selected-plan-info .discount-billing-price')
        .remove();
      $_upgradePage.find('.billing-form .form-field.code .code-input').val('');
      $_upgradePage.find('.billing-form .form-field #plan-id').val('');
      $_upgradePage
        .find('.billing-form .submit-billing-form-button .selected-plan-name')
        .text('');

      // reset billing form user info
      $_upgradePage.find('.billing-form').trigger('reset');
    };

    const _applyPricingAdjustments = function (pricingData) {
      var _planName, // planName does not come across from API call, must look it up in DOM
        $_discountPlanCard;

      const _planId =
        pricingData.subscription_plan_id === undefined
          ? pricingData.id
          : pricingData.subscription_plan_id;
      const _planKey =
        pricingData.subscription_plan_key === undefined
          ? pricingData.key
          : pricingData.subscription_plan_key;

      const _discountCode = pricingData.code,
        _planBillingPrice = pricingData.dollars,
        _planBillingRate = pricingData.term,
        _planMonthlyPrice = pricingData.monthly_dollar_amount,
        _discountPercentage = pricingData.discount_percentage,
        _discountBillingPrice = pricingData.discount_price_in_dollars,
        _discountMonthlyPrice = parseFloat(
          pricingData.discount_monthly_dollar_amount,
        )
          .toFixed(2)
          .toString();

      // cache Plan Card corresponding to pricing data, look up _planName
      $_discountPlanCard = $_upgradePage.find(
        '.pricing-plan.card[data-plan-id=' + _planId + ']',
      );
      _planName = $_discountPlanCard.data('plan-name');

      // select and apply discounting to card corresponding to pricing data
      $_discountPlanCard.addClass('selected').addClass('discounted');

      if (
        _planKey &&
        _planKey.startsWith('lifetime') &&
        $_discountPlanCard.find('.plan-price').find('.discount-lump-price')
          .length < 1
      ) {
        $_discountPlanCard
          .find('.plan-price .plan-lump-price')
          .after(
            '<span class="discount-lump-price"> ' +
              _discountBillingPrice +
              '</span>',
          );
      } else if (
        $_discountPlanCard.find('.plan-price').find('.discount-monthly-price')
          .length < 1
      ) {
        $_discountPlanCard
          .find('.plan-price .plan-monthly-price')
          .after(
            '<span class="discount-monthly-price"> $' +
              _discountMonthlyPrice +
              '</span>',
          );
        $_discountPlanCard
          .find('.plan-price-info .plan-billing-price')
          .after(
            '<span class="discount-billing-price"> ' +
              _discountBillingPrice +
              '</span>',
          );
      }

      const base_discount_message =
        '<span class="discount-billing-price"> ' +
        _discountBillingPrice +
        '</span>';
      const percent_message =
        '<span class="savings"> (' +
        _discountPercentage +
        '% savings with your discount code)</span>';
      const discount_message =
        _discountPercentage === undefined
          ? base_discount_message
          : base_discount_message + percent_message;

      // update billing form with discount data
      $_upgradePage
        .find('.billing-form .selected-plan-info .selected-plan')
        .text(_planName);
      $_upgradePage
        .find('.billing-form .selected-plan-info')
        .addClass('discounted');

      $_upgradePage
        .find('.billing-form .selected-plan-info .plan-billing-price')
        .after(discount_message);

      $_upgradePage
        .find('.billing-form .form-field.code .code-input')
        .val(_discountCode);
      $_upgradePage
        .find('.billing-form .submit-billing-form-button .selected-plan-name')
        .text(_planName);
      $_upgradePage
        .find('.billing-form .form-field.plan-id .field-value')
        .val(_planId);
    };

    const _displaySignInOrUpModal = function () {
      if (window.openRegisterModal) {
        window.openRegisterModal({
          source: 'pricing',
          returnTo: window.location.href,
        });
        return;
      }

      // ensure that react component is loaded before attempting
      if (
        typeof window.gSignInOrUp !== 'undefined' &&
        window.gSignInOrUp !== null
      ) {
        window.gSignInOrUp._handleBeginClick();
      }
    };

    /*
    ==================================================
     INTERACTION WITH PLATFORM API
    ==================================================
    */

    /* Validate Promo Code
    ================================================== */
    const _validatePromoCode = function (args) {
      var _promoCode = args.promoCode,
        _selectedPlanId = args.selectedPlanId || null,
        _successCallback = args.success || null,
        _errorCallback = args.error || null,
        _reqUrl = '/api/subscriptions/check_code';

      // pass _promoCode to API
      $.ajax({
        url: _reqUrl,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify({
          authenticity_token: _getAuthenticityToken(),
          stripeCouponCode: _promoCode,
          plan_id: _selectedPlanId,
        }),
        success: function (data) {
          if (
            _successCallback !== null &&
            typeof _successCallback == 'function'
          ) {
            _successCallback.call(this, data);
          }
        },
        error: function (data) {
          if (_errorCallback !== null && typeof _errorCallback == 'function') {
            _errorCallback.call(this, data.responseJSON);
          }
        },
      });
    };

    /* Process response from Stripe Element Token service
    ================================================== */
    const _stripeTokenHandler = function (stripeToken) {
      var form$ = $_upgradePage.find('.billing-form');

      var _stripeCoupon = _billingFormCodeInputField().val();
      var _saleContext = $("meta[name='saleContext']").attr('content');
      var _serializedFormAsJSON = {
        stripeToken: stripeToken.id,
        authenticity_token: _getAuthenticityToken(),
        plan_id: $('#plan-id').val(),
        paymentGateway: $('#paymentGateway').val(),
        name: $('#full-name').val(),
        email: $('#e-mail').val(),
        number: stripeToken.card.last4,
        exp_month: stripeToken.card.exp_month,
        exp_year: stripeToken.card.exp_year,
        address_zip: stripeToken.card.address_zip,
        address_zip_check: stripeToken.card.address_zip_check,
        cvc_check: stripeToken.card.cvc_check,
        stripeCouponCode: _stripeCoupon,
      };

      if (
        typeof _stripeCoupon !== 'undefined' &&
        _stripeCoupon !== null &&
        _stripeCoupon != ''
      ) {
        _serializedFormAsJSON['stripeCouponCode'] = _stripeCoupon;
      }

      if (
        typeof _saleContext !== 'undefined' &&
        _saleContext !== null &&
        _saleContext != ''
      ) {
        _serializedFormAsJSON['saleContext'] = _saleContext;
      }

      legacyEBPublish('upgrade:purchase:token_created', {}, true);

      $.ajax({
        type: form$.attr('method'),
        url: '/api/subscriptions/subscribe.json',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        dataType: 'json',
        data: JSON.stringify(_serializedFormAsJSON), // serializes the form's elements.
        error: function (data) {
          $('#payment-errors').text(JSON.parse(data.responseText).message);

          // Re-enable the submit button on the form
          form$.find('button').prop('disabled', false);
          $_upgradePage
            .find('.billing-form .submit-billing-form-button')
            .removeClass('loading');
        },
        success: function (data) {
          // clear the ccd-details from the form
          form$.get(0).reset();

          location.href =
            '/subscriptions/thanks?id=' +
            data.subscription_id +
            '&key=' +
            data.subscription_plan_key;
        },
      });
    };

    const _handlePlanKeyInUrl = function () {
      var _planKey = _getUrlParameter('key'),
        _planCard;

      if (typeof _planKey !== 'undefined' && _planKey !== null) {
        $_planCard = $_upgradePage.find(
          '.pricing-plan.card[data-plan-key=' + _planKey + ']',
        );

        if (
          $_planCard.length > 0 &&
          typeof $_planCard.data('plan-id') != 'undefined'
        ) {
          _displayBilling($_planCard.data('plan-id'));
        }
      }
    };

    const _handlePromoCodeInUrl = function () {
      var _theCode = _getUrlParameter('code');

      if (typeof _theCode !== 'undefined' && _theCode !== null) {
        // automate the input and submission of the promo code into either the pre-plan-selection form or the billing form

        if ($_upgradePage.find('.billing-form').first().is(':visible')) {
          // the billing form is being displayed, submit through the billing form
          $_upgradePage
            .find('.billing-form .form-field.code .code-input')
            .val(_theCode);
          $_upgradePage
            .find('.billing-form .form-field.code .code-apply')
            .click();
        } else {
          // submit the code through the pre-plan-selection form
          $_upgradePage.find('.code-prompt').hide();
          $_upgradePage
            .find('#pre-plan-code-input.code-form .code-input')
            .val(_theCode);
          $_upgradePage.find('#pre-plan-code-input.code-form').show();
          $_upgradePage
            .find('#pre-plan-code-input.code-form .code-apply')
            .click();
        }
      }
    };

    const _handleCspReEntry = function () {
      var isCspReEntry = _getUrlParameter('cspReEntry'),
        _selectedPlanId;

      if (
        typeof isCspReEntry !== 'undefined' &&
        isCspReEntry !== null &&
        isCspReEntry
      ) {
        _selectedPlanId = $(this).data('plan-id');
        _displayBilling(_selectedPlanId);
      }
    };

    // clear the ccd-details from the form
    $_upgradePage.find('.billing-form').get(0).reset();

    /* Handle URL params -- auto-load billing form
    ================================================== */
    if (!$_upgradePage.hasClass('custom-selling-page')) {
      _handlePlanKeyInUrl();
      _handlePromoCodeInUrl();
    } else {
      _handleCspReEntry();
    }
  },
}

export default pricingPage;
